import { Box, Skeleton } from "@mui/material";
import Cropper from "cropperjs";
import React from "react";
import { Cropper as CropperComponent } from "react-cropper";
import { useTranslation } from "react-i18next";
import { useStepClickHandler } from "./hooks/useStepClickHandler";
import { useWPR } from "./hooks/useWPR";
import { useWPRContext } from "./hooks/useWPRContext";
import { StepChildProps } from "./WPRStepper";

// export function timeout(ms: number) {
//   return new Promise((resolve) => {
//     setTimeout(resolve, ms);
//   });
// }

export const WPRStepTwo = ({
  setActiveStep,
  setStepChangeClickedType,
  stepChangeClickedType,
}: StepChildProps) => {
  const { base64Url, selectedExcelBase } = useWPRContext();
  const { mutateAsync } = useWPR();
  const [cropper, setCropper] = React.useState<Cropper | undefined>();
  const { t } = useTranslation("");
  const handleBackStep = React.useCallback(() => {}, []);

  const handleUpload = React.useCallback(async () => {
    if (selectedExcelBase?.id === undefined) return Promise.resolve();

    const croppedUrl = cropper?.getCroppedCanvas().toDataURL();
    return mutateAsync({
      base64Url: croppedUrl ?? base64Url,
      templateNodeId: selectedExcelBase?.id,
    });
  }, [base64Url, cropper, mutateAsync, selectedExcelBase?.id]);

  useStepClickHandler({
    nextStepFn: handleUpload,
    setActiveStep,
    backStepFn: handleBackStep,
    stepChangeClickedType,
    setStepChangeClickedType,
    loadingText: t("WPR:generatingExcel"),
  });

  return base64Url ? (
    <Box
      sx={{
        ".cropper-view-box": {
          outline: "2px solid black !important",
        },
        ".cropper-point": {
          backgroundColor: "black",
        },
      }}
    >
      <CropperComponent
        // zoomTo={0.5}

        // preview=".img-preview"
        src={base64Url}
        // viewMode={1}

        background={false}
        responsive
        autoCropArea={1}
        checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
        onInitialized={(instance) => {
          if (instance) {
            setCropper(instance);
          }
        }}
        guides
      />
    </Box>
  ) : (
    <Skeleton />
  );
};
